import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_DIET_CATEGORY,
  UPDATE_DIET_CATEGORY_DETAILS,
} from '../action-types'
import { DIET_CATEGORY_INITIAL_STATE } from '../initial-states'

const dietCategoryReducer = (state = DIET_CATEGORY_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DIET_CATEGORY.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: [],
        }),
      )

    case FETCH_DIET_CATEGORY.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.dietCategory,
        }),
      )

    case FETCH_DIET_CATEGORY.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: [],
        }),
      )

    case FETCH_DIET_CATEGORY.CLEANUP:
      return { ...DIET_CATEGORY_INITIAL_STATE }

    case UPDATE_DIET_CATEGORY_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
        }),
      )

    case UPDATE_DIET_CATEGORY_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDietCategoryDetails,
          ),
          isDirty: false,
        }),
      )

    case UPDATE_DIET_CATEGORY_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
        }),
      )

    default:
      return state
  }
}

export default dietCategoryReducer
